import { extendTheme } from "@chakra-ui/react";

const colors = {
  primary: {
    100: "rgb(21, 198, 221)",
  }
};

const customTheme = extendTheme({ colors });

export default customTheme;